import { useTranslation, Trans } from "react-i18next";

import m1 from '../../img/m1.png';
import m2 from '../../img/m2.png';

import check from '../../img/check.svg';

function Problems () {

    const { t } = useTranslation();
      
    return(
        <>
            <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
                <div className="flex flex-col md:flex-row justify-between gap-[40px] md:gap-[20px]">
                    <div>
                        <p className="host-grotesk leading-[1.2] xl:text-[40px] text-[#382F12] text-[28px] xl:max-w-[566px]">{t('home.24')}</p>
                        <div className="flex items-start gap-[20px] mt-[46px] border-b border-[#CECABE] pb-[20px]">
                            <img src={check} alt="" className="mt-[5px]"/>
                            <div>
                                <p className="host-grotesk xl:text-[20px] leading-[1.2] text-[16px]">{t('home.25')}</p>
                                <p className="PtRoot text-[#000000B2] text-[12px] xl:text-[14px] mt-[6px]">{t('home.26')}</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[20px] mt-[20px] border-b border-[#CECABE] pb-[20px]">
                            <img src={check} alt="" className="mt-[5px]"/>
                            <div>
                                <p className="host-grotesk xl:text-[20px] leading-[1.2] text-[16px]">{t('home.27')}</p>
                                <p className="PtRoot text-[#000000B2] text-[12px] xl:text-[14px] mt-[6px]">{t('home.28')}</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[20px] mt-[20px] border-b border-[#CECABE] pb-[20px]">
                            <img src={check} alt="" className="mt-[5px]"/>
                            <div>
                                <p className="host-grotesk xl:text-[20px] leading-[1.2] text-[16px]">{t('home.29')}</p>
                                <p className="PtRoot text-[#000000B2] text-[12px] xl:text-[14px] mt-[6px]">{t('home.30')}</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[20px] mt-[20px] border-b border-[#CECABE] pb-[20px]">
                            <img src={check} alt="" className="mt-[5px]"/>
                            <div>
                                <p className="host-grotesk xl:text-[20px] leading-[1.2] text-[16px]">{t('home.31')}</p>
                                <p className="PtRoot text-[#000000B2] text-[12px] xl:text-[14px] mt-[6px]">{t('home.32')}</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-[20px] mt-[20px]">
                            <img src={check} alt="" className="mt-[5px]"/>
                            <div>
                                <p className="host-grotesk xl:text-[20px] leading-[1.2] text-[16px]">{t('home.33')}</p>
                                <p className="PtRoot text-[#000000B2] text-[12px] xl:text-[14px] mt-[6px]">{t('home.34')}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img src={m1} alt="" />
                    </div>
                </div>  
                <div className="flex flex-col-reverse md:flex-row gap-[40px] md:gap-[20px] xl:gap-[85px] md:mt-[40px] xl:mt-0">
                    <div>
                        <img src={m2} alt="" />
                    </div>
                    <div className="mt-[80px] md:mt-0 xl:mt-[93px] flex flex-col items-start">
                        <p className="host-grotesk leading-[1.2] xl:text-[64px] text-[#382F12] text-[40px] xl:max-w-[566px]">{t('home.35')}</p>
                        <p className="PtRoot text-[#000000B2] text-[16px] xl:text-[20px] mt-[20px] xl:max-w-[515px]">{t('home.36')}</p>
                        <div className="flex items-center gap-[14px] mt-[40px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <path d="M3.26371e-09 3C1.46121e-09 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 5.06621e-09 4.65685 3.26371e-09 3Z" fill="#FC2E00"/>
                            </svg>
                            <p className="host-grotesk text-[16px] xl:text-[20px] leading-[1.2]">{t('home.37')}</p>
                        </div>
                        <div className="flex items-center gap-[14px] mt-[20px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <path d="M3.26371e-09 3C1.46121e-09 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 5.06621e-09 4.65685 3.26371e-09 3Z" fill="#FC2E00"/>
                            </svg>
                            <p className="host-grotesk text-[16px] xl:text-[20px] leading-[1.2]">{t('home.38')}</p>
                        </div>
                        <div className="flex items-center gap-[14px] mt-[20px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <path d="M3.26371e-09 3C1.46121e-09 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 5.06621e-09 4.65685 3.26371e-09 3Z" fill="#FC2E00"/>
                            </svg>
                            <p className="host-grotesk text-[16px] xl:text-[20px] leading-[1.2]">{t('home.39')}</p>
                        </div>
                        <div className="flex items-center gap-[14px] mt-[20px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <path d="M3.26371e-09 3C1.46121e-09 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 5.06621e-09 4.65685 3.26371e-09 3Z" fill="#FC2E00"/>
                            </svg>
                            <p className="host-grotesk text-[16px] xl:text-[20px] leading-[1.2]">{t('home.40')}</p>
                        </div>
                        <div className="flex items-center gap-[14px] mt-[20px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <path d="M3.26371e-09 3C1.46121e-09 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3C6 4.65685 4.65685 6 3 6C1.34315 6 5.06621e-09 4.65685 3.26371e-09 3Z" fill="#FC2E00"/>
                            </svg>
                            <p className="host-grotesk text-[16px] xl:text-[20px] leading-[1.2]">{t('home.41')}</p>
                        </div>
                        <p className="rounded-[8px] bg-[#FC2E00] text-white uppercase PtRoot font-[700] py-[14px] mt-[40px] xl:mt-0 xl:absolute px-[40px] bottom-[0px] hover:px-[20px] transition-all">{t('home.8')}</p>
                    </div>
                    
                </div>
            </div>
        </>
    );
}

export default Problems;